export default __webpack_public_path__ + "static/bg-d7585dbf5966b740aaf763377f86c330.webm";